import React from 'react';

const SEOWizard: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="10.6vw"
      height="10.6vw"
    >
      <g fillRule="evenodd">
        <path
          fill="#C1D9FF"
          d="M17.5 25a3.5 3.5 0 1 1 0-7h14.441a12.883 12.883 0 0 0-2.251-4.548c-5.328-6.864-15.581-6.864-20.909 0-3.63 4.677-3.63 11.385 0 16.063 5.328 6.864 15.581 6.864 20.909 0A12.918 12.918 0 0 0 31.932 25H17.5z"
        ></path>
        <path fill="#C1D9FF" d="M42.5 25H34v-7h8.5a3.5 3.5 0 1 1 0 7"></path>
        <path
          fill="#1F77FF"
          d="M19.5 6c-4.582 0-9.164 2.02-12.297 6.057-4.27 5.5-4.27 13.392 0 18.893 3.133 4.038 7.715 6.057 12.297 6.057 4.582 0 9.164-2.02 12.297-6.057 4.27-5.501 4.27-13.392 0-18.893C28.664 8.02 24.082 6 19.5 6m0 5c3.271 0 6.314 1.503 8.348 4.122 2.87 3.697 2.87 9.065 0 12.763-2.034 2.619-5.077 4.122-8.348 4.122-3.271 0-6.314-1.503-8.348-4.122-2.87-3.698-2.87-9.066 0-12.763C13.186 12.502 16.229 11 19.5 11"
        ></path>
        <path
          fill="#1F77FF"
          d="M41.111 39.455l-10.559-10.56-3.767 3.77 10.557 10.559a2.674 2.674 0 0 0 3.77 0 2.674 2.674 0 0 0 0-3.77"
        ></path>
      </g>
    </svg>
  );

const VideoMaker: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="10.6vw"
      height="10.6vw"
    >
      <g fillRule="evenodd">
        <path
          fill="#C1D9FF"
          d="M16.5 15h-3c-.825 0-1.5-.675-1.5-1.5 0-.824.675-1.5 1.5-1.5h3c.825 0 1.5.676 1.5 1.5 0 .825-.675 1.5-1.5 1.5zm0 21h-3c-.825 0-1.5-.675-1.5-1.5 0-.824.675-1.5 1.5-1.5h3c.825 0 1.5.676 1.5 1.5 0 .825-.675 1.5-1.5 1.5zm-8-21h-2c-.825 0-1.5-.675-1.5-1.5 0-.824.675-1.5 1.5-1.5h2c.825 0 1.5.676 1.5 1.5 0 .825-.675 1.5-1.5 1.5zm0 21h-2c-.825 0-1.5-.675-1.5-1.5 0-.824.675-1.5 1.5-1.5h2c.825 0 1.5.676 1.5 1.5 0 .825-.675 1.5-1.5 1.5zM5 9a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h28V9H5z"
          data-color="1"
        ></path>
        <path
          fill="#1F77FF"
          d="M46 24c0 9.39-7.611 17-17 17s-17-7.61-17-17S19.611 7 29 7s17 7.61 17 17"
          data-color="2"
        ></path>
        <path
          fill="#C1D9FF"
          d="M24 19.264v9.472c0 1.425 1.548 2.314 2.779 1.595l8.158-4.76c1.225-.716 1.221-2.488-.007-3.197l-8.159-4.71c-1.231-.712-2.771.178-2.771 1.6"
          data-color="1"
        ></path>
      </g>
    </svg>
  );

const PriceQuotes: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="10.6vw"
      height="10.6vw"
    >
      <g fillRule="evenodd">
        <path
          fill="#1F77FF"
          d="M31.633 20.952a4.004 4.004 0 0 1-4.584-4.585c.259-1.685 1.636-3.061 3.319-3.318a4.004 4.004 0 0 1 4.583 4.584c-.257 1.684-1.633 3.06-3.318 3.319zM40 10a2 2 0 0 0-2-2H24.862a3.983 3.983 0 0 0-2.827 1.17L5.484 25.752a2.977 2.977 0 0 0 .008 4.213L18.064 42.5a2.998 2.998 0 0 0 4.239-.003l16.525-16.525A4 4 0 0 0 40 23.143V10.002z"
          data-color="1"
        ></path>
        <path
          fill="#C1D9FF"
          d="M19.102 37.47l-8.567-8.57a1.5 1.5 0 0 1 0-2.122l5.53-5.53a1.5 1.5 0 0 1 2.122 0l8.568 8.568a1.5 1.5 0 0 1 0 2.121l-5.531 5.531a1.501 1.501 0 0 1-2.122 0"
          data-color="2"
        ></path>
        <path
          fill="#C1D9FF"
          d="M33.012 15.992a.999.999 0 0 1-.707-1.707l9.988-9.992a1 1 0 1 1 1.414 1.414l-9.988 9.992a.997.997 0 0 1-.707.293"
          data-color="2"
        ></path>
      </g>
    </svg>
  );

const MarketingIntegrations: React.FunctionComponent<
  React.SVGAttributes<SVGElement>
> = () => (
  <svg
    viewBox="4.001 6 42 38.001"
    fill="currentColor"
    width="10.6vw"
    height="10.6vw"
  >
    <g fillRule="evenodd">
      <path
        fill="#C1D9FF"
        d="M30 42H18l-2-9 2-9v-5.5a2.5 2.5 0 0 1 2.5-2.5H32l-2 26z"
        data-color="1"
      ></path>
      <path
        fill="#1F77FF"
        d="M18 42H8.5A2.5 2.5 0 0 1 6 39.5v-13A2.5 2.5 0 0 1 8.5 24H18v18z"
        data-color="2"
      ></path>
      <path
        fill="#1F77FF"
        d="M30.059 42h9.434a2.5 2.5 0 0 0 2.5-2.504l-.05-29A2.5 2.5 0 0 0 39.443 8H32.5a2.501 2.501 0 0 0-2.5 2.505L30.059 42z"
        data-color="2"
      ></path>
    </g>
  </svg>
);

const ContactManager: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="10.6vw"
      height="10.6vw"
    >
      <g fillRule="evenodd">
        <path
          fill="#C1D9FF"
          d="M45.127 36.64a12.632 12.632 0 0 0-8.082-8.588c-.314-.106-.363-.522-.094-.718a6.82 6.82 0 0 0 2.788-4.673h.313c.719 0 1.407-.426 1.627-1.11a1.61 1.61 0 0 0-.243-1.482v-3.803c0-5.098-4.681-9.153-9.96-8.098-4.12.824-6.97 4.624-6.97 8.825v3.076c-.296.396-.424.92-.243 1.484.219.683.908 1.108 1.626 1.108h.312c.116.931.433 1.796.889 2.571h-6.18c.456-.775.773-1.64.889-2.57h.312c.718 0 1.407-.426 1.626-1.109a1.605 1.605 0 0 0-.243-1.484v-3.076c0-4.2-2.85-8-6.97-8.825-5.279-1.055-9.96 3-9.96 8.098v3.803a1.61 1.61 0 0 0-.242 1.481c.219.685.908 1.111 1.626 1.111h.313a6.82 6.82 0 0 0 2.788 4.673c.269.196.221.612-.094.718a12.634 12.634 0 0 0-8.082 8.588C2.546 37.833 3.495 39 4.732 39h38.536c1.237 0 2.186-1.167 1.859-2.36"
          data-color="1"
        ></path>
        <path
          fill="#1F77FF"
          d="M38.925 38.877A16.86 16.86 0 0 0 27.619 30.2a.38.38 0 0 1-.303-.373.39.39 0 0 1 .21-.346c2.378-1.175 4.105-3.48 4.447-6.212h.463a1.925 1.925 0 0 0 1.918-1.916c0-.428-.147-.819-.384-1.138V16.18C33.97 10.58 29.384 6 23.779 6c-5.362 0-9.75 4.38-9.75 9.736v4.478a1.9 1.9 0 0 0-.382 1.138c0 1.052.863 1.916 1.918 1.916h.463c.34 2.732 2.069 5.037 4.446 6.212a.39.39 0 0 1 .21.346.38.38 0 0 1-.303.373 16.855 16.855 0 0 0-11.306 8.68c-.737 1.42.27 3.12 1.87 3.12h26.109c1.6 0 2.608-1.7 1.87-3.122"
          data-color="2"
        ></path>
      </g>
    </svg>
  );

const TasksAndReminders: React.FunctionComponent<
  React.SVGAttributes<SVGElement>
> = () => (
  <svg
    viewBox="4.001 6 42 38.001"
    fill="currentColor"
    width="10.6vw"
    height="10.6vw"
  >
    <g fillRule="evenodd">
      <path
        fill="#C1D9FF"
        d="M39 36H13.5a1.5 1.5 0 0 1-1.5-1.5V9a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3"
        data-color="1"
      ></path>
      <path
        fill="#1F77FF"
        d="M33 42H9a3 3 0 0 1-3-3V15a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3"
        data-color="2"
      ></path>
      <path
        fill="#C1D9FF"
        d="M19.013 32.402c-.384 0-.768-.146-1.061-.44l-3.832-3.83a1.5 1.5 0 1 1 2.12-2.121l2.772 2.77 6.2-6.198a1.5 1.5 0 1 1 2.12 2.12l-7.26 7.26a1.495 1.495 0 0 1-1.06.44"
        data-color="1"
      ></path>
    </g>
  </svg>
);

export {
  SEOWizard,
  VideoMaker,
  PriceQuotes,
  MarketingIntegrations,
  ContactManager,
  TasksAndReminders,
};
